"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFormQuestionPopulatedJobFieldEnum = void 0;
var OrderFormQuestionPopulatedJobFieldEnum;
(function (OrderFormQuestionPopulatedJobFieldEnum) {
    OrderFormQuestionPopulatedJobFieldEnum["BRAND2"] = "brand2";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_EMAIL_FOR_INVOICES"] = "customerEmailForInvoices";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_EMAIL_FOR_ORDERS"] = "customerEmailForOrders";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_FIRSTNAME"] = "customerFirstname";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_LASTNAME"] = "customerLastname";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_MOBILE_PHONE"] = "customerMobilePhone";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_PHONE"] = "customerPhone";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SALUTATION"] = "customerSalutation";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SHIPPING_CITY"] = "customerShippingCity";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SHIPPING_COUNTRY_CODE"] = "customerShippingCountryCode";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SHIPPING_POSTALCODE"] = "customerShippingPostalCode";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SHIPPING_STREET"] = "customerShippingStreet";
    OrderFormQuestionPopulatedJobFieldEnum["CUSTOMER_SIGNATURE"] = "customerSignature";
    OrderFormQuestionPopulatedJobFieldEnum["EID"] = "eid";
    OrderFormQuestionPopulatedJobFieldEnum["INTERNAL_COMMENTS"] = "internal_comments";
    OrderFormQuestionPopulatedJobFieldEnum["INVOICING_EID"] = "externalInvoicingId";
    OrderFormQuestionPopulatedJobFieldEnum["OWN_INSTALLER"] = "ownInstaller";
    OrderFormQuestionPopulatedJobFieldEnum["PROJECT_ID"] = "projectId";
})(OrderFormQuestionPopulatedJobFieldEnum = exports.OrderFormQuestionPopulatedJobFieldEnum || (exports.OrderFormQuestionPopulatedJobFieldEnum = {}));
//# sourceMappingURL=order-form-question-populated-job-field-enum.js.map